module.exports = __webpack_public_path__ + "static/bg-service-2812e1733d5b0e94ec2bb038dbed170a.png";